import { createPinia, PiniaPlugin } from 'pinia'
import Vue from 'vue'

Vue.use(PiniaPlugin)

const pinia = createPinia()

export default pinia
